import { render } from "./ComingSoon.vue?vue&type=template&id=1422d50e&scoped=true"
import script from "./ComingSoon.vue?vue&type=script&lang=js"
export * from "./ComingSoon.vue?vue&type=script&lang=js"

import "./ComingSoon.vue?vue&type=style&index=0&id=1422d50e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1422d50e"]])

export default __exports__